document.addEventListener('DOMContentLoaded', function() {
  var forms = document.querySelectorAll('form.title-sku-search-form');

  forms.forEach(function(form) {
    var userInput = form.querySelector('input[name="user_query"]');
    var shopifyQ = form.querySelector('input[name="q"]');

    if (!userInput || !shopifyQ) return;

    form.addEventListener('submit', function() {
      var raw = (userInput.value || '').trim();
      if (!raw) return;

      var safe = raw.replace(/"/g, '\\"');

      // Strict search: title + SKU only
      shopifyQ.value = 'title:"' + safe + '" OR sku:"' + safe + '"';
    });
  });
});